import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";
/**
 * External dependencies
 */

import classNames from 'classnames';
/**
 * WordPress dependencies
 */

import { URLPopover } from '@wordpress/block-editor';
import { useState } from '@wordpress/element';
import { Button, IconButton } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { getIconBySite } from './social-list';

var SocialLinkEdit = function SocialLinkEdit(_ref) {
  var attributes = _ref.attributes,
      setAttributes = _ref.setAttributes,
      isSelected = _ref.isSelected;
  var url = attributes.url,
      site = attributes.site;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showURLPopover = _useState2[0],
      setPopover = _useState2[1];

  var classes = classNames('wp-social-link', 'wp-social-link-' + site, {
    'wp-social-link__is-incomplete': !url
  }); // Import icon.

  var IconComponent = getIconBySite(site);
  return createElement(Button, {
    className: classes,
    onClick: function onClick() {
      return setPopover(true);
    }
  }, createElement(IconComponent, null), isSelected && showURLPopover && createElement(URLPopover, {
    onClose: function onClose() {
      return setPopover(false);
    }
  }, createElement("form", {
    className: "block-editor-url-popover__link-editor",
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      setPopover(false);
    }
  }, createElement("div", {
    className: "editor-url-input block-editor-url-input"
  }, createElement("input", {
    type: "text",
    value: url,
    onChange: function onChange(event) {
      return setAttributes({
        url: event.target.value
      });
    },
    placeholder: __('Enter Address')
  })), createElement(IconButton, {
    icon: "editor-break",
    label: __('Apply'),
    type: "submit"
  }))));
};

export default SocialLinkEdit;